module.exports = {
  id: 12,
  name: 'Side Lunges',
  categories: ['strength', 'legs', 'balance'],
  sports: [
    'baseball',
    'basketball',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'intermediate',
  skill: 'Strength',
  points: 11,
  instructions:
    'Side Lunges make your legs strong and flexible! Stand with your feet apart, step to the right and bend your right knee, then step to the left and bend your left knee!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to lunge to the side? Let us build incredible leg strength!',
    },
    {
      time: 3,
      text: 'Stand with your feet apart. Keep your chest up and core engaged!',
    },
    {
      time: 6,
      text: 'Step to the right and bend your right knee, then step to the left and bend your left knee! Fantastic work. Now try your left leg. Step to the left and bend your left knee, then step to the right and bend your right knee! Great job! Now you know how to do side lunges!',
    },
    // SET 1 - 10 lunges
    {
      time: 12,
      text: "Let's begin the workout! Feet apart, chest up!",
    },
    {
      time: 15,
      text: 'Number 1! Step to the right and bend your right knee! Fantastic form.',
    },
    {
      time: 18,
      text: 'Keep your left leg straight, push back to center!',
    },
    {
      time: 21,
      text: 'Number 2! Step to the left and bend your left knee!',
    },
    {
      time: 24,
      text: 'Keep your right leg straight, push back to center! Great work!',
    },
    {
      time: 27,
      text: 'Number 3! Step to the right and bend your right knee!',
    },
    {
      time: 30,
      text: 'Keep your left leg straight, push back to center!',
    },
    {
      time: 33,
      text: 'Number 4! Step to the left and bend your left knee! Feel the burn?',
    },
    {
      time: 36,
      text: 'Keep your right leg straight, push back to center!',
    },
    {
      time: 39,
      text: 'Number 5! Step to the right and bend your right knee!',
    },
    {
      time: 42,
      text: "Keep your left leg straight, push back to center! Let's go!",
    },
    {
      time: 45,
      text: 'Number 6! Step to the left and bend your left knee!',
    },
    {
      time: 48,
      text: 'Keep your right leg straight, push back to center! Great work!',
    },
    {
      time: 51,
      text: 'Number 7! Step to the right and bend your right knee!',
    },
    {
      time: 54,
      text: "Keep your left leg straight, push back to center! You're a pro!",
    },
    {
      time: 57,
      text: 'Number 8! Step to the left and bend your left knee!',
    },
    {
      time: 60,
      text: 'Keep your right leg straight, push back to center! Boom! Fantastic!',
    },
    {
      time: 63,
      text: 'Number 9! Step to the right and bend your right knee!',
    },
    {
      time: 66,
      text: 'Keep your left leg straight, push back to center! Almost there!',
    },
    {
      time: 69,
      text: 'Number 10! Step to the left and bend your left knee!',
    },
    {
      time: 72,
      text: 'Keep your right leg straight, push back to center!',
    },
    {
      time: 75,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 78,
      text: 'Take a deep breath in and out, you are building incredible leg strength!',
    },
    {
      time: 81,
      text: 'Shake out your legs and feet, get ready for round two!',
    },
    {
      time: 84,
      text: 'You are doing amazing! Ready for round two? Let us keep going!',
    },
    {
      time: 87,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 2 - 10 lunges
    {
      time: 90,
      text: 'Stand with your feet apart, ready to lunge!',
    },
    {
      time: 93,
      text: 'Keep your chest up and core engaged!',
    },
    {
      time: 96,
      text: "Let's aim for perfect side lunge form! Step to the right and bend your knee!",
    },
    {
      time: 99,
      text: 'Number 1! Step to the right and bend your right knee! Keep your core engaged! Your core is the strength you have in your stomach. It is the most important part of your body. It helps you balance and stay strong.',
    },
    {
      time: 102,
      text: 'Keep your left leg straight, push back to center! Great work!',
    },
    {
      time: 105,
      text: 'Number 2! Step to the left and bend your left knee!',
    },
    {
      time: 108,
      text: 'Keep your right leg straight, push back to center! Keep proper form!',
    },
    {
      time: 111,
      text: 'Number 3! Step to the right and bend your right knee!',
    },
    {
      time: 114,
      text: 'Keep your left leg straight, push back to center! Fanastic! Feel it in your core, strengthen your stomach muscles.',
    },
    {
      time: 117,
      text: 'Number 4! Step to the left and bend your left knee!',
    },
    {
      time: 120,
      text: 'Keep your right leg straight, push back to center! We are getting stronger! Keep your core tight!',
    },
    {
      time: 123,
      text: 'Number 5! Step to the right and bend your right knee!',
    },
    {
      time: 126,
      text: 'Keep your left leg straight, push back to center! Can you feel the burn?',
    },
    {
      time: 129,
      text: 'Number 6! Step to the left and bend your left knee!',
    },
    {
      time: 132,
      text: 'Keep your right leg straight, push back to center! Great work!',
    },
    {
      time: 135,
      text: 'Number 7! Step to the right and bend your right knee!',
    },
    {
      time: 138,
      text: 'Keep your left leg straight, push back to center! Almost there!',
    },
    {
      time: 141,
      text: 'Number 8! Step to the left and bend your left knee!',
    },
    {
      time: 144,
      text: 'Keep your right leg straight, push back to center! Hold that form...great! Core engaged always!',
    },
    {
      time: 147,
      text: 'Number 9! Step to the right and bend your right knee!',
    },
    {
      time: 150,
      text: 'Keep your left leg straight, push back to center! You are getting stronger!',
    },
    {
      time: 153,
      text: 'Number 10! Step to the left and bend your left knee!',
    },
    {
      time: 156,
      text: 'Keep your right leg straight, push back to center!',
    },
    {
      time: 159,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 162,
      text: 'Take a deep breath in and out, you are building incredible leg strength!',
    },
    {
      time: 165,
      text: 'Shake out your legs and feet, get ready for the final round!',
    },
    {
      time: 168,
      text: 'You are doing amazing! Ready for the final round? Let us finish strong!',
    },
    {
      time: 171,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 3 - 10 lunges
    {
      time: 174,
      text: 'Stand with your feet apart, ready to lunge!',
    },
    {
      time: 177,
      text: 'Keep your chest up and core engaged!',
    },
    {
      time: 180,
      text: 'Step to the right and bend your knee! Fantastic form!',
    },
    {
      time: 186,
      text: 'Keep your left leg straight, push back to center! Hold it for longer this time. This is the last set.',
    },
    {
      time: 189,
      text: 'Number 2! Step to the left and bend your left knee!',
    },
    {
      time: 192,
      text: 'Keep your right leg straight, push back to center! Hold it, focus on the form. Keep your core engaged!',
    },
    {
      time: 195,
      text: 'Number 3! Step to the right and bend your right knee!',
    },
    {
      time: 198,
      text: 'Keep your left leg straight, push back to center!',
    },
    {
      time: 201,
      text: 'Number 4! Step to the left and bend your left knee! Feel the burn? Tighten your stomach muscles! Keep your core engaged!',
    },
    {
      time: 204,
      text: 'Keep your right leg straight, push back to center!',
    },
    {
      time: 207,
      text: 'Number 5! Step to the right and bend your right knee! Put some more weight on your right knee and feel the power.',
    },
    {
      time: 210,
      text: 'Keep your left leg straight, push back to center!',
    },
    {
      time: 213,
      text: 'Number 6! Step to the left and bend your left knee! Put some more weight on your left knee now and push your left foot deeper into the ground.',
    },
    {
      time: 216,
      text: 'Keep your right leg straight, push back to center!',
    },
    {
      time: 219,
      text: 'Number 7! Step to the right and bend your right knee! Push that right foot deeper into the ground and feel your right leg muscles working hard!',
    },
    {
      time: 222,
      text: 'Keep your left leg straight, push back to center!',
    },
    {
      time: 225,
      text: 'Number 8! Step to the left and bend your left knee! Keep your core strong, feel your stomach muscles tighten. This is your inner strength!',
    },
    {
      time: 228,
      text: 'Keep your right leg straight, push back to center!',
    },
    {
      time: 231,
      text: 'Number 9! Step to the right and bend your right knee! Push that right foot deeper into the ground and feel your right leg muscles working hard!',
    },
    {
      time: 234,
      text: 'Keep your left leg straight, push back to center!',
    },
    {
      time: 237,
      text: 'Number 10! Step to the left and bend your left knee!',
    },
    {
      time: 240,
      text: 'Keep your right leg straight, push back to center!',
    },
    {
      time: 243,
      text: 'Incredible work! You are done! You just completed all three sets!',
    },
    // COMPLETION
    {
      time: 246,
      text: 'Amazing work! You did 30 side lunges and built incredible leg strength!',
    },
    {
      time: 249,
      text: 'Your legs are getting super strong and flexible! You are a lunge master!',
    },
    {
      time: 252,
      text: 'Great job, strength champion! You are building incredible power!',
    },
  ],
};
